export default __webpack_public_path__ + "static/media/reset password.6dc9f005.png";